jQuery(document).ready(function() {
	if(window.matchMedia('(min-width:768px)').matches){
		if(jQuery('.key-resource__slider').length > 0){
			jQuery('.key-resource__slider').slick({
				infinite: true,
				speed: 600,
				arrows: true,
				slidesToShow:9,
				cssEase:'linear',
				nextArrow: '<button class="fa fa-arrow-right right-arrow"><span class="sr-only">right arrow</span></button>',
				prevArrow: '<button class="fa fa-arrow-left left-arrow"><span class="sr-only">left arrow</span></button>',
				responsive: [
					{
					  breakpoint: 1200,
					  settings: {
						slidesToShow:8,
						}
					},
					{
					  breakpoint: 1030,
					  settings: {
						slidesToShow:6,
						}
					},
				]
			});
		}
	}
	
	jQuery( window ).resize(function() {
		if(window.matchMedia('(min-width:768px)').matches){
			if(jQuery('.key-resource__slider').length > 0){
				jQuery('.key-resource__slider').not('.slick-initialized').slick({
					infinite: true,
					speed: 600,
					arrows: true,
					slidesToShow:9,
					cssEase:'linear',
					nextArrow: '<button class="fa fa-arrow-right right-arrow"><span class="sr-only">right arrow</span></button>',
					prevArrow: '<button class="fa fa-arrow-left left-arrow"><span class="sr-only">left arrow</span></button>',
					responsive: [
						{
						  breakpoint: 1200,
						  settings: {
							slidesToShow:8,
							}
						},
						{
						  breakpoint: 1030,
						  settings: {
							slidesToShow:6,
							}
						},
					]
				});
			}
		}
		if(window.matchMedia('(max-width:767px)').matches){
			jQuery('.key-resource__slider').slick('unslick');
		}
	});
}); //Document Ready End
